<template>
  <transition name="transition-slide-right">
    <Detail v-if="!!orderDetail" />
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
import Detail from './Detail'
export default {
  name: 'OrderDetail',
  components: { Detail },
  computed: {
    ...mapGetters(['orderDetail'])
  }
}
</script>
